import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './modules/auth'
import user from './modules/user'
import app from './modules/app'
import posts from './modules/posts'
import ai from './modules/ai'
import analytics from './modules/analytics'
import recurring from './modules/recurring'
import billing from './modules/billing'
import storage from './modules/storage'
import admin from './modules/admin'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    app,
    posts,
    ai,
    analytics,
    recurring,
    billing,
    storage,
    admin,
  },
  plugins: [
    createPersistedState({
      paths: ['auth.user', 'auth.isLoggedIn'],
    }),
  ],
})
